export var ValueLanguage;
(function (ValueLanguage) {
    ValueLanguage["Afrikaans"] = "Afrikaans";
    ValueLanguage["Albanian"] = "Albanian";
    ValueLanguage["AngloSaxon"] = "Anglo-Saxon";
    ValueLanguage["Catalan"] = "Catalan";
    ValueLanguage["CatalanSpn"] = "Catalan_Spn";
    ValueLanguage["Czech"] = "Czech";
    ValueLanguage["Danish"] = "Danish";
    ValueLanguage["Dutch"] = "Dutch";
    ValueLanguage["English"] = "English";
    ValueLanguage["Esperanto"] = "Esperanto";
    ValueLanguage["Estonian"] = "Estonian";
    ValueLanguage["Faroese"] = "Faroese";
    ValueLanguage["Finnish"] = "Finnish";
    ValueLanguage["French"] = "French";
    ValueLanguage["German"] = "German";
    ValueLanguage["Hawaiian"] = "Hawaiian";
    ValueLanguage["Hungarian"] = "Hungarian";
    ValueLanguage["Icelandic"] = "Icelandic";
    ValueLanguage["Indonesian"] = "Indonesian";
    ValueLanguage["Italian"] = "Italian";
    ValueLanguage["Latvian"] = "Latvian";
    ValueLanguage["Lithuanian"] = "Lithuanian";
    ValueLanguage["Navaho"] = "Navaho";
    ValueLanguage["Norwegian"] = "Norwegian";
    ValueLanguage["Polish"] = "Polish";
    ValueLanguage["Portuguese"] = "Portuguese";
    ValueLanguage["Romanian"] = "Romanian";
    ValueLanguage["SerboCroa"] = "Serbo_Croa";
    ValueLanguage["Slovak"] = "Slovak";
    ValueLanguage["Slovene"] = "Slovene";
    ValueLanguage["Spanish"] = "Spanish";
    ValueLanguage["Swedish"] = "Swedish";
    ValueLanguage["Turkish"] = "Turkish";
    ValueLanguage["Wendic"] = "Wendic";
    // Unicode-based
    ValueLanguage["Amharic"] = "Amharic";
    ValueLanguage["Arabic"] = "Arabic";
    ValueLanguage["Armenian"] = "Armenian";
    ValueLanguage["Assamese"] = "Assamese";
    ValueLanguage["Belorusian"] = "Belorusian";
    ValueLanguage["Bengali"] = "Bengali";
    ValueLanguage["Braj"] = "Braj";
    ValueLanguage["Bulgarian"] = "Bulgarian";
    ValueLanguage["Burmese"] = "Burmese";
    ValueLanguage["Cantonese"] = "Cantonese";
    ValueLanguage["ChurchSlavic"] = "Church-Slavic";
    ValueLanguage["Dogri"] = "Dogri";
    ValueLanguage["Georgian"] = "Georgian";
    ValueLanguage["Greek"] = "Greek";
    ValueLanguage["Gujarati"] = "Gujarati";
    ValueLanguage["Hebrew"] = "Hebrew";
    ValueLanguage["Hindi"] = "Hindi";
    ValueLanguage["Japanese"] = "Japanese";
    ValueLanguage["Kannada"] = "Kannada";
    ValueLanguage["Khmer"] = "Khmer";
    ValueLanguage["Konkani"] = "Konkani";
    ValueLanguage["Korean"] = "Korean";
    ValueLanguage["Lahnda"] = "Lahnda";
    ValueLanguage["Lao"] = "Lao";
    ValueLanguage["Macedonian"] = "Macedonian";
    ValueLanguage["Maithili"] = "Maithili";
    ValueLanguage["Malayalam"] = "Malayalam";
    ValueLanguage["Mandarin"] = "Mandarin";
    ValueLanguage["Manipuri"] = "Manipuri";
    ValueLanguage["Marathi"] = "Marathi";
    ValueLanguage["Mewari"] = "Mewari";
    ValueLanguage["Nepali"] = "Nepali";
    ValueLanguage["Oriya"] = "Oriya";
    ValueLanguage["Pahari"] = "Pahari";
    ValueLanguage["Pali"] = "Pali";
    ValueLanguage["Panjabi"] = "Panjabi";
    ValueLanguage["Persian"] = "Persian";
    ValueLanguage["Prakrit"] = "Prakrit";
    ValueLanguage["Pusto"] = "Pusto";
    ValueLanguage["Rajasthani"] = "Rajasthani";
    ValueLanguage["Russian"] = "Russian";
    ValueLanguage["Sanskrit"] = "Sanskrit";
    ValueLanguage["Serb"] = "Serb";
    ValueLanguage["Tagalog"] = "Tagalog";
    ValueLanguage["Tamil"] = "Tamil";
    ValueLanguage["Telugu"] = "Telugu";
    ValueLanguage["Thai"] = "Thai";
    ValueLanguage["Tibetan"] = "Tibetan";
    ValueLanguage["Ukrainian"] = "Ukrainian";
    ValueLanguage["Urdu"] = "Urdu";
    ValueLanguage["Vietnamese"] = "Vietnamese";
    ValueLanguage["Yiddish"] = "Yiddish";
})(ValueLanguage || (ValueLanguage = {}));
//# sourceMappingURL=ValueLanguage.js.map